// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"177":"e9338805","443":"cbd70ce3","794":"dcdb6088"}[chunkId] + ".js";
};